import "../../styles/NavigatorСodeTextArea.css";
import { useGame } from "../../GameContext";

type TextAreaProps = {
  sceneHeight: number;
};

const TextArea = ({ sceneHeight }: TextAreaProps) => {
  const { guessedWords } = useGame();

  return (
    <div
      className="navigatorСode-Area"
      style={{ height: `${sceneHeight}vw` }}
    >
      <div className="navigatorСode-subtitle">
        Найденные слова
      </div>

      <div className="navigatorСode-textArea">
        {guessedWords.map((word, index) => (
          <div key={index}>{word}</div>
        ))}
      </div>
    </div>
  );
};
export default TextArea;
